import {
  GET_JURISDICTION_AREA_LIST_FULFILLED,
  JurisdictionAreaActionTypes,
  JurisdictionAreaState,
  GET_JURISDICTION_AREA_LIST,
  DELETE_JURISDICTION_AREA_FULFILLED,
  SELECT_JURISDICTION_AREA,
  OPEN_JURISDICTION_AREA_CREATE_PAGE,
  CLOSE_JURISDICTION_AREA_CREATE_PAGE,
  OPEN_JURISDICTION_AREA_EDIT_PAGE,
  CLOSE_JURISDICTION_AREA_EDIT_PAGE,
  CREATE_JURISDICTION_AREA_FULFILLED,
  CREATE_JURISDICTION_AREA_PENDING,
} from './jurisdictionArea.types';

export const initialState: JurisdictionAreaState = {
  entities: [],
  single: null,
  selected: [],
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isEditPopupOpen: false,
    isLoading: false
  }
};

export default function jurisdictionAreaReducer(
  state = initialState,
  action: JurisdictionAreaActionTypes,
): JurisdictionAreaState {
  switch (action.type) {
    case GET_JURISDICTION_AREA_LIST:
      return {
        ...state,
        selected: []
      };

    case GET_JURISDICTION_AREA_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: []
      };

    case SELECT_JURISDICTION_AREA:
      return {
        ...state,
        selected: action.payload || []
      };

    case CREATE_JURISDICTION_AREA_PENDING:
      return {
        ...state,
        createdId: null
      };

    case CREATE_JURISDICTION_AREA_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null
      };

    case DELETE_JURISDICTION_AREA_FULFILLED:
      return {
        ...state,
        selected: []
      };

    case OPEN_JURISDICTION_AREA_CREATE_PAGE:
      return {
        ...state,
        single: null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true
        }
      };

    case CLOSE_JURISDICTION_AREA_CREATE_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false
        }
      };

    case OPEN_JURISDICTION_AREA_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: true
        }
      };

    case CLOSE_JURISDICTION_AREA_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: false
        }
      };

    default:
      return state;
  }
}
